import { useState, type FC, type SVGProps } from 'react'
import classNames from 'classnames'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useInView } from 'react-intersection-observer'

import { Text } from 'components'
import {
  IPService,
  PowerService,
  VideoService,
  IntercomService,
  LightingService,
  SprinklerService,
  AutomationService,
  CommunicationService,
} from 'assets'

import AccordionItem from '../Hero/AccordionItem'
import { getService, resolveLang } from '../../ServicesPage/servicesCatalog'
import styles from './Commitment.module.scss'
import { Slide } from 'react-awesome-reveal'

const commitmentItems = [
  { title: 'commitmentItem1', content: 'commitmentItem1Desc' },
  { title: 'commitmentItem2', content: 'commitmentItem2Desc' },
  { title: 'commitmentItem3', content: 'commitmentItem3Desc' },
  { title: 'commitmentItem4', content: 'commitmentItem4Desc' },
  { title: 'commitmentItem5', content: 'commitmentItem5Desc' },
  { title: 'commitmentItem6', content: 'commitmentItem6Desc' },
  { title: 'commitmentItem7', content: 'commitmentItem7Desc' },
  { title: 'commitmentItem8', content: 'commitmentItem8Desc' },
]

const scatteredIcons: Array<{ Icon: FC<SVGProps<SVGSVGElement>>; positionClass: string; slug: string }> = [
  { Icon: LightingService, positionClass: styles.iconsCloud__icon_1, slug: 'lighting' },
  { Icon: VideoService, positionClass: styles.iconsCloud__icon_2, slug: 'video-surveillance' },
  { Icon: AutomationService, positionClass: styles.iconsCloud__icon_3, slug: 'automation' },
  { Icon: PowerService, positionClass: styles.iconsCloud__icon_4, slug: 'power-supply' },
  { Icon: CommunicationService, positionClass: styles.iconsCloud__icon_5, slug: 'networks-cabling' },
  { Icon: IntercomService, positionClass: styles.iconsCloud__icon_6, slug: 'intercom' },
  { Icon: SprinklerService, positionClass: styles.iconsCloud__icon_7, slug: 'fire-suppression' },
  { Icon: IPService, positionClass: styles.iconsCloud__icon_8, slug: 'ip-telephony' },
]

const Commitment: FC = () => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const lang = resolveLang(i18n.language)
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 })
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const navigateToContactUs = () => {
    navigate('/contact-us')
  }

  return (
    <div className='bg_dark'>
      <div className={classNames(styles.wrapper, 'container')}>
        <div className={styles.wrapper__block}>
          <div className={styles.wrapper__block_info}>
            <Slide direction={'left'} triggerOnce>
              <Text text='whyChooseUs' className={styles.wrapper__block_info_text} tagName='h2' />
            </Slide>
            <div className={styles.wrapper__block_info_list}>
              {commitmentItems.map((item, index) => (
                <AccordionItem
                  key={item.title}
                  title={item.title}
                  content={item.content}
                  isOpen={openIndex === index}
                  onToggle={() => setOpenIndex(openIndex === index ? null : index)}
                  compact
                />
              ))}
            </div>
            <button className={styles.wrapper__block_info_btn} onClick={navigateToContactUs}>
              <Text text={'contactUs'} />
            </button>
          </div>
        </div>
        <div className={styles.wrapper__block_img}>
          <div className={classNames(styles.iconsCloud, { [styles.iconsCloud_inView]: inView })} ref={ref}>
            {scatteredIcons.map(({ Icon, positionClass, slug }, index) => {
              const title = getService(slug)?.titles[lang]

              return (
                <Link
                  key={index}
                  to={`/services/${slug}`}
                  className={classNames(styles.iconsCloud__icon, positionClass)}
                  aria-label={title}
                  title={title}
                >
                  <Icon />
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Commitment
